import createIcon from '../../createIcon';

/**
 * @component @name Snowmobile
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTYuNUMyMiAxNy4wNSAyMS41NSAxNy41IDIxIDE3LjVIMjAuODNMMTguNjMgMTUuM0MyMC41OCAxNC44NyAyMiAxMy45IDIyIDEyLjVDMjIgMTEuNSAxNCA0LjUgMTQgNC41SDExVjYuNUgxMy4yNUwxNC43IDcuOEwxMSAxMC41TDEuNSA5LjVMMCAxMi41TDQuNTQgMTMuODZMMS4wNSAxNS43NEMtMC43NyAxNi43MiAtMC4wNjk5OTk5IDE5LjUgMiAxOS41SDhDMTAuMjEgMTkuNSAxMiAxNy43MSAxMiAxNS41SDE2TDE4IDE3LjVIMTVWMTkuNUgyMUMyMi42NiAxOS41IDI0IDE4LjE2IDI0IDE2LjVIMjJaTTggMTcuNUgyTDcuMjUgMTQuNjdMMTAgMTUuNUMxMCAxNi42IDkuMTEgMTcuNSA4IDE3LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Snowmobile = createIcon('Snowmobile', [
  [
    'path',
    {
      d: 'M22 16.5C22 17.05 21.55 17.5 21 17.5H20.83L18.63 15.3C20.58 14.87 22 13.9 22 12.5C22 11.5 14 4.5 14 4.5H11V6.5H13.25L14.7 7.8L11 10.5L1.5 9.5L0 12.5L4.54 13.86L1.05 15.74C-0.77 16.72 -0.0699999 19.5 2 19.5H8C10.21 19.5 12 17.71 12 15.5H16L18 17.5H15V19.5H21C22.66 19.5 24 18.16 24 16.5H22ZM8 17.5H2L7.25 14.67L10 15.5C10 16.6 9.11 17.5 8 17.5Z',
      key: '11tga5',
    },
  ],
]);

export default Snowmobile;
